/**
 * Created by JackCui on 2021/2/1
 */

import { batchHandleUrl } from '../../utils/url-handle.js'

const paasEdit = {
  // 值对象-详情
  valueDetails: {
    url: '/apaas/object/value/get',
    type: 'post'
  },
  // 值对象-详情
  getSlaveDetails: {
    url: '/apaas/object/value/getManyObjetValue',
    type: 'post'
  },
  // 删除
  deleteDetail: {
    url: '/apaas/object/value/delete',
    type: 'post'
  }
}

export default batchHandleUrl(paasEdit)